<template>
  <div
    v-if="statusInfo"
    class="row items-center justify-center q-px-sm q-py-xs dass-card-status-order"
    :class="[statusInfo.bg, statusInfo.text]"
    style="min-width: 110px; font-weight: 600;"
  >
    <q-icon :name="statusInfo.icon" size="16px" class="q-mr-xs" />
    <span>{{ statusInfo.label }}</span>
  </div>
</template>
<script>
import { StatusOrder } from '@/helpers/constants/StatusOrder'

export default {
  name: 'CardStatusOrder',
  props: {
    statusPed: {
      type: String,
      default: ''
    }
  },
  computed: {
    statusInfo() {        
      const key = this.statusPed?.toUpperCase();      
      return StatusOrder[key] || null;
    }    
  },  
}
</script>

<style scoped>
.dass-card-status-order {
  border-radius: var(--border-radius-card);
}

.dass-card-status-order > span {
  text-align: center;
}
</style>